<div
  class="app__itemCard mr-4 h-full justify-normal mx-auto sm:mx-0 cursor-pointer mobile-card-design"
  [class]="
    isFromHomePage
      ? 'w-full h-[299px] p-0 border-none box-shadow-none'
      : fromBalanceRegister && !fromCurrentBalance
      ? ' w-full sm:w-full'
      : fromCurrentBalance
      ? ' p-0 border-none w-full sm:w-full'
      : 'sm:w-[460px] w-[350px] sm:h-[280px] max-[1309px]:px-[10px]'
  "
>
  @if (isFamilyTreeCard) {
  <div class="flex flex-col h-full " (click)="familyTreeHandlers?.navigate?.(familyTree.id)">
    <div class="flex items-start justify-between">
      <div class="flex flex-col">
        <h4 class="text-base font-semibold text-[#1E1E20] mb-1">
          {{ familyTree?.name || 'Untitled Family Tree' }}
        </h4>
      </div>
      <button
        mat-icon-button
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="familyTreeMenu"
        [disableRipple]="true" style="width: 20px" class="top-[-10px]"
      >
        <span class="material-icons">more_vert</span>
      </button>
    </div>
    <div class="flex-1 rounded-xl border border-[#E4E8F0] bg-[#EFF6FA] flex items-center justify-center">
      <img class="w-[140.311px] h-[186.632px]" [src]="familyTreeCardImage" alt="Family tree illustration" />
    </div>
    <mat-menu #familyTreeMenu="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
      <button mat-menu-item class="family__tree--popup--menuitem" (click)="familyTreeHandlers?.navigate?.(familyTree.id)">
        <span class="material-icons menuitem-icon material-symbols-outlined text-k-blue text-xl">visibility</span>
        View Family Tree
      </button>
      @if (familyTree?.current_user_role === 'admin' || familyTree?.current_user_role === 'manager') {
      <button mat-menu-item class="family__tree--popup--menuitem" (click)="familyTreeHandlers?.manage?.(true, familyTree.id)">
        <span class="material-icons menuitem-icon material-symbols-outlined text-k-blue text-xl">group</span>
        Manage Members
      </button>
      <button mat-menu-item class="family__tree--popup--menuitem" (click)="familyTreeHandlers?.rename?.(familyTree)">
        <span class="material-icons menuitem-icon material-symbols-outlined text-k-blue text-xl material-icons-round">edit</span>
        Rename
      </button>
      @if (familyTree?.current_user_role === 'admin') {
      <button mat-menu-item class="family__tree--popup--menuitem text-[#EB5757]" (click)="familyTreeHandlers?.delete?.(familyTree)">
        <span class="material-icons menuitem-icon material-symbols-outlined text-[#EB5757] text-xl">delete_outline</span>
        Delete
      </button>
      } }
    </mat-menu>
  </div>
  } @else {
  @if (!isLoading && !isFromHomePage && !isFromTemplate) {
  <div class="flex flex-row justify-between">
    <div (click)="$event.stopPropagation(); !fromBalanceRegister && moveToReport($event)">
      <h4
        class="cursor-pointer"
        [matTooltip]="report?.name?.length > 22 ? report?.name : ''"
        [class]="fromBalanceRegister ? 'app__form--attribute--title text-sm flex gap-2' : 'app__itemCard-label'"
      >
        <div class="flex items-center">
          <div class="h-[22px]">{{ report?.name | truncateStrPipe : 30 }}</div>
        </div>
      </h4>
      @if (!fromBalanceRegister) {
      <span style="color: #707070">
        <report-tag
          [report]="report"
          [period_time]="period_time"
          [isLoading]="isLoading"
          [isUdpatedDate]="isUdpatedDate"
          [isUpdate]="report_tag_isUpdate"
          (onResetGraphClickedEvent)="onResetViewClicked($event)"
        ></report-tag>
      </span>
      }
    </div>
    @if (!fromBalanceRegister) {
    <div class="popup-menu">
      <button mat-icon-button [matMenuTriggerFor]="menuItem" [disableRipple]="true" style="width: 20px">
        <span class="material-icons">more_vert</span>
      </button>
      <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
        <button mat-menu-item class="popup-menu-item" (click)="moveToReport($event)">
          <p class="flex items-center font-open-sans font-normal text-[14px] leading-[19px] mb-0 text-[#000000] gap-[14px]">
            <span class="material-icons material-icons-round menuitem-icon text-k-blue">remove_red_eye</span>View Report
          </p>
        </button>
        <button mat-menu-item class="popup-menu-item" (click)="openUpdateDialog(report)">
          <p class="flex items-center font-open-sans font-normal text-[14px] leading-[19px] mb-0 text-[#000000] gap-[14px]">
            <span class="material-icons material-icons-round menuitem-icon text-k-blue">edit</span>Rename
          </p>
        </button>
        @if (currentuserId === report.user_id && !report.is_system) {
        <button mat-menu-item class="popup-menu-item" (click)="deleteReport(report)">
          <p
            class="flex items-center font-open-sans font-normal text-[14px] leading-[19px] mb-0 text-[#000000] gap-[14px]"
            style="color: red !important"
          >
            <span class="material-icons material-icons-round menuitem-icon text-red-500">delete</span>Delete Report
          </p>
        </button>
        }
      </mat-menu>
    </div>
    } @if (fromBalanceRegister) {
    <div class="flex items-center">
      <p class="font-normal text-sm text-black mr-2 mb-0">
        {{ fromCurrentBalance ? 'View' : 'Data Range' }}
      </p>
      &nbsp;
      <button
        class="rounded-lg mt-[-5px] text-k-blue flex flex-row-reverse items-center"
        [matMenuTriggerFor]="menuItem"
        [disableRipple]="true"
        mat-button
        style="border: 1px solid rgba(211, 220, 232, 0.7)"
      >
        {{ selectedRangeText }}
        <span class="material-icons menu-icon play-arrow text-k-blue"> expand_more </span>
      </button>
      <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="w-full popup-menu-panel">
        @for (item of dateRange; track item) {
        <li mat-menu-item class="dropdown-item-list overflow-hidden whitespace-nowrap" (click)="updateDateRange(item)">
          <span [matTooltip]="item.displayText" class="text-ellipsis w-[135px]">
            {{ item.displayText | truncateStrPipe : 16 }}
          </span>
        </li>
        }
      </mat-menu>
    </div>
    }
  </div>
  }
  <div class="relative" (click)="$event.stopPropagation(); !fromBalanceRegister && moveToReport($event)">
    @if(!isLoading && action !== 'updating') { 
      @if(isFromHomePage) {
        <canvas
          [ngClass]="[showZeroState || (!isLoading && action !== 'updating' && report.type == 'ownership') ? '!hidden' : '']"
          #myCanvas
          baseChart
          [attr.width]="reportWidgetContainerWidth"
          height="270px"
          [data]="lineChartData"
          [options]="lineChartOptions"
          [type]="lineChartType"
        ></canvas>
        }@else{
          <canvas
            [ngClass]="[showZeroState || (!isLoading && action !== 'updating' && report.type == 'ownership') ? '!hidden' : '']"
            #myCanvas
            baseChart
            width="400"
            height="200px"
            style="height: 200px !important; max-height: 200px !important"
            [data]="lineChartData"
            [options]="lineChartOptions"
            [type]="lineChartType"
          ></canvas>
        } 
    }
   @if (report_execution_id && showZeroState && report.type == 'assetMap' && action != 'updating') {
    <small-asset-map-chart [isFromHomePage]="isFromHomePage" [report_execution_id]="report_execution_id"> </small-asset-map-chart>
    } @if (reportExecution && report_execution_id && showZeroState && action != 'updating' && isCashReport) {
    <small-sankey-chart [trendExecutionSub]="reportExecution" [isFromHomePage]="isFromHomePage"></small-sankey-chart>
    } @if(!isLoading && action != 'updating' && showRefreshPrompt && reportCardOnHomePage){
    <div class="absolute top-0 left-0 right-0 bottom-0 z-[1000] bg-[#00000066] rounded-[12px]" style="height: 100vh"></div>
    <div class="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[1001]" [ngClass]="{ 'h-[299px]': isFromHomePage }">
      <div class="page-refresh-container">
        <div class="bg-[#FFFFFF] w-fit h-[46px] pl-[15px] pr-[12px] rounded-[6px] gap-6 flex items-center justify-between">
          <div class="leading-normal font-open-sans text-[15.36px] font-normal text-[#25508E] flex gap-2 justify-center items-center">
            <mat-icon class="text-[#25508E]">info_outline</mat-icon>
            <span>Updates Available</span>
          </div>
          <div class="flex w-fit h-fit items-center justify-center gap-2">
            <button class="custom-fill-light-blue-button h-[26px] w-[72px] text-[11.52px] leading-normal">Refresh</button>
            <mat-icon class="text-[#828282]" (click)="closeRefreshPrompt($event)">close</mat-icon>
          </div>
        </div>
      </div>
    </div>
    } @if (report_execution_id && showZeroState && !isBalanceReport && action == 'updating') {
    <div class="ph-item bg-" style="padding: 0px; margin-bottom: 0px; border: 0px">
      <div class="ph-col-12" style="padding: 0px">
        <div class="ph-row">
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
        </div>
      </div>
    </div>
    } @if (isBalanceReport && action == 'updating') {
    <div class="ph-item bg-" style="padding: 0px; margin-bottom: 0px; border: 0px">
      <div class="ph-col-12" style="padding: 0px">
        <div class="ph-row">
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
        </div>
      </div>
    </div>
    } @if (isLoading) {
    <div class="ph-item mt-7 bg-" style="padding: 0px; margin-bottom: 0px; border: 0px">
      <div class="ph-col-12" style="padding: 0px">
        <div class="ph-row">
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
          <div class="ph-col-12" style="height: 24px; margin: 12px 0px"></div>
        </div>
      </div>
    </div>
    } @if (showZeroState && isBalanceReport && action !== 'updating') {
    <div class="bg-[#EFF6FA]">
      <img class="max-w-full flex mx-auto" style="padding: 25.5px" src="assets/images/no-report-data.svg" />
    </div>
    } @if (report.type == 'ownership' && !isLoading && action !== 'updating') {
    <div>
      @if (!isFromHomePage) {
      <div class="h-[180px] w-full bg-[#EFF6FA] rounded-[10px] flex items-center justify-center">
        @if (s3Img) {
        <img width="418" height="180" src="{{ s3Img }}" />
        } @if (!s3Img) {
        <img width="144" height="128" src="assets/images/ownershipMap/noResultCard.svg" />
        }
      </div>
      }@else {
      <div class="w-full h-[299px] bg-[#EFF6FA] rounded-[10px] flex items-center justify-center">
        @if (s3Img) {
        <img class="w-full" src="{{ s3Img }}" />
        } @if (!s3Img) {
        <img width="418" height="180" src="assets/images/ownershipMap/noResultCard.svg" />
        }
      </div>
      }
      <!-- <div style="display: flex;justify-content: center;align-items: center;background: #EFF6FA;">
        <img width="144" height="128" src="assets/images/ownershipMap/noResult.svg" />
      </div> -->
    </div>
    }
  </div>
  }
</div>
